import { i18n } from '../../i18n/i18n';
import { obj } from '../../models/common-types';
import { Filter, FilterOption, FiltersState, OutputFilters, ServiceFiltersCluster } from './filter-types';
import _ from 'lodash';

const MAP_ORDER = {
    sites: 1,
    socialNetworks: 1,
    accountTypes: 1,
    accountsBySite: 2,
    authorBySite: 3,
    type: 4,
    engagement: 5,
    interactions: 6,
    featuresDetected: 7,
    taggedLocation: 8,
    location: 9,
    locationsExists: 10,
};
const formatOptions = (filterOptions: any): FilterOption[] => {
    if (!Array.isArray(filterOptions)) {
        const options: FilterOption[] = [];
        Object.keys(filterOptions).forEach((key: string) => {
            filterOptions[key].forEach((opt: any) => {
                options.push({
                    key: key,
                    label: opt.label,
                    count: opt.count,
                    value: opt.value,
                });
            });
        });
        return options;
    } else {
        return filterOptions.map((option) => ({
            label: option.label,
            count: option.count,
            value: option.value,
            group: option.group,
            displayName: option.displayName,
        }));
    }
};

export const formatInputFilters = (
    filters: ServiceFiltersCluster,
    context: string,
    overrideFiltersProperties?: (filterName: string) => Partial<Filter>,
): Filter[] => {
    const result = _.orderBy(
        Object.entries(filters)
            .filter((filter) => filter[1])
            .map(([filterName, options]) => ({
                name: i18n.translate(`${context}_${filterName}`),
                originalName: filterName,
                order: MAP_ORDER[filterName],
                options: formatOptions(options),
                selectionType: 'multi',
                searchableOptions: true,
                ...overrideFiltersProperties?.(filterName),
            }))
            .filter((filter) => filter.options.length) as Filter[],
        ['order'],
        ['asc'],
    );
    return result;
};

export const formatOutputFilters = (
    filters: FiltersState,
    additionalOutputFormatter?: (rawFilters: FiltersState) => obj<any>,
): OutputFilters => {
    if (!filters) return {};
    const outputFilters: OutputFilters = {};
    const finalFilters = Object.entries(filters!!).filter((filter) => filter[1]);

    finalFilters.forEach(([filterName, options]) => {
        outputFilters[filterName] = Array.isArray(options) ? options.map((opt) => opt.value) : options!!.value;
    });

    return { ...outputFilters, ...additionalOutputFormatter?.(filters) };
};
